export const xlat = {};
//# sourceMappingURL=index.js.map